// Bespoke billing experience(s) that need to be handled differently by Finance team only.
export const SEGMENT_KEY_MANUAL_BILLING_EXPERIENCE =
  "manual-billing-management";
export const FEATURE_FLAG_KEY_MANUAL_BILLING_EXPERIENCE =
  "web_billing_manual_billing_management";

export const FEATURE_FLAG_CREDIT_CARD_LESS_EXPERIENCE =
  "web_billing_trial_ccless_upgrade";
